import { render, staticRenderFns } from "./selects.vue?vue&type=template&id=0598c786"
import script from "./selects.vue?vue&type=script&lang=js"
export * from "./selects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports